
import React from 'react';
import cx from './toggle.less';

export default class Toggle extends React.Component<any, any> {
    isOn = this.props.isOn;
    handleToggle = this.props.handleToggle;
    textLabel = this.props.textLabel;
    key = this.props.id;
    render() {
        this.isOn = this.props.isOn;
        this.handleToggle = this.props.handleToggle;
        this.textLabel = this.props.textLabel;
        this.key = this.props.id;

        return (
            <div id={this.key} className={cx(this.isOn ? 'react-switch-on': 'react-switch-off')}>
              <label className={cx('react-switch-text')}>{this.textLabel}</label>
              <input
                checked={this.isOn}
                onChange={this.handleToggle}
                className={cx('react-switch-checkbox')}
                id={`react-switch-new-` + this.key}
                type="checkbox"
              />
              <label
                className={cx('react-switch-label')}
                htmlFor={`react-switch-new-` + this.key}
              >              
                <span className={cx('react-switch-button')} />
              </label>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/react-toolbox-extended/toggle.tsx